import * as z from "zod/v4";

export const getMarketplaceRevenue = {
  name: "getMarketplaceRevenue" as const,
  input: z.object({ startDate: z.date(), endDate: z.date() }),
  output: z.object({ revenue: z.number() }),
};
